<template>
    <button ref="btn" :disabled="disabled || isSubmitting" @click="submit">
        <slot></slot>
    </button>
</template>

<script>
    export default {
        name: 'SubmitButton',
        data() {
            return {
                isSubmitting: false
            };
        },
        props: {
            click: {
                type: Function,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            submit() {
                this.isSubmitting = true;
                const promise = this.click();
                if (!promise || promise instanceof Promise !== true) {
                    throw new Error('SubmitButton click function must return a promise');
                }
                promise.finally(() => {
                    this.isSubmitting = false;
                });
            },
            focus() {
                this.$refs.btn.focus();
            }
        }
    };
</script>